<template>
  <Snackbar class="snackbar" :value="snackbarVisible">
    {{ snackbarMessage }}
    <template v-slot:action>
      <button class="close-button" @click="$emit('hideSnackbar')">
        <span class="close-button-text">CLOSE</span>
      </button>
    </template>
  </Snackbar>
</template>

<script>
import { mapState } from 'vuex';
import { Snackbar } from '@mikmak/components';

export default {
  components: {
    Snackbar,
  },
  computed: {
    ...mapState({
      snackbarVisible: ({ main: { snackbarVisible } }) => snackbarVisible,
      snackbarMessage: ({ main: { snackbarMessage } }) => snackbarMessage,
      snackbarState: ({ main: { snackbarState } }) => snackbarState,
    }),
  },
};

</script>

<style scoped lang="scss">
  .close-button {
    height: 36px;
    width: 64px;
    margin-right: 10px;
    line-height: 21px;
    cursor: pointer;
  }

  .close-button-text {
    float: right;
  }

  .snackbar::v-deep {
    .v-snack__content {
      font-weight: 400;
    }

    .v-snack__action {
      font-weight: 500;
      margin: 0;
    }

    .v-snack__wrapper {
      max-width: 407px;
    }
  }
</style>
